module.exports = __webpack_public_path__ + "img/01.429e0076.jpg";